import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ProductItem } from './productitem.service';

export class UserPermissions {
  ruleId: number;
  canEdit: boolean;
  canDelete: boolean;
  canCreate: boolean;
  canView: boolean;
  lob: string;
  sector: { sectorId: number, sector: string };
  region: { regionId: number, region: string };
  user: Users;

  constructor() {

    let sector = "";
    let sectorId = -1;
    this.sector = { sectorId, sector };

    let regionId = -1;
    let region = "";
    this.region = { regionId, region };

    let user = new Users();
    this.user = user;
  }
}

export class BrandLeadUser {
  brandId: number;
  itemId: ProductItem;
  userId: Users;
}

export class Users {
  constructor() {

    let role = new UserRole();
    role.roleId = -1;
    role.userRole = "";
    role.userManagement = false;
    role.customerManagement = false;
    role.lookupManagement = false;
    role.techLeadAccess = false;
    this.role = role;


       // Initialize appliancesRole
       let applianceRole = new ApplianceRoles();
       applianceRole.roleId = -1;
       applianceRole.roleName = "";
       applianceRole.orderManagement = false;
       applianceRole.stockManagement = false;
       applianceRole.inventoryManagement = false;
       applianceRole.fileProcessingManagement = false;
       applianceRole.RFPManagement = false;
        applianceRole.prospectsManagement = false;
       applianceRole.accessLevel = 0;
       this.appliancesRole = applianceRole;
  }

  public userId: number;
  public empId: number;
  public managerId: number;
  public quota: number;
  public status: number;
  public firstName: String;
  public lastName: String;
  public email: String;
  public password: String;
  public region: string;
  public manager: string;
  public role: UserRole;
  public appliancesRole: ApplianceRole | undefined;
}

export class UserRole {
  constructor() { }
  public roleId: number;
  public userRole: String;
  public userManagement: boolean;
  public customerManagement: boolean;
  public lookupManagement: boolean;
  public techLeadAccess: boolean;
}

export class ApplianceRoles {
  roleId: number | undefined;
  orderManagement: boolean;
  stockManagement: boolean;
  inventoryManagement: boolean;
  fileProcessingManagement: boolean;
  RFPManagement: boolean;
  prospectsManagement: boolean;
  accessLevel: Number;
  roleName: String;

  constructor() {
    this.roleId = -1;
    this.orderManagement = false;
    this.stockManagement = false;
    this.inventoryManagement = false;
    this.fileProcessingManagement = false;
    this.RFPManagement = false;
    this.prospectsManagement = false;
    this.accessLevel = 0;
    this.roleName = "";
  }
}


export interface ApplianceRole {
  roleId: number;
  orderManagement: boolean;
  stockManagement: boolean;
  inventoryManagement: boolean;
  fileProcessingManagement: boolean;
  RFPManagement: boolean;
  prospectsManagement: boolean;
  accessLevel: Number;
  roleName: String;
}

@Injectable({
  providedIn: 'root'
})

export class SalesService {

  constructor(private httpClient: HttpClient) { }

  private AppliancePATH = "/appliances/api/v2/applianceRole";

  findSalesUsersByManager(region: string, sector: string): Observable<Users[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<Users[]>('/api/v1/user/sales/' + region + '/' + sector, { headers })
      .pipe(catchError(this.errorHandler));
  }

  retrieveAllUsers(): Observable<Users[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<Users[]>('/api/v1/user/', { headers })
      .pipe(catchError(this.errorHandler));
  }

  retrievePopularSales(): Observable<Users[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<Users[]>('/api/v1/user/popularSales', { headers })
      .pipe(catchError(this.errorHandler));
  }

  findUserByEmail(email: string): Observable<Users[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<Users[]>('/api/v1/user/userbyemail/' + email, { headers })
      .pipe(catchError(this.errorHandler));
  }

  retrieveMainData(): Observable<Users[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<Users[]>('/api/v1/user/mainData/', { headers })
      .pipe(catchError(this.errorHandler));
  }

  retrieveManagers(): Observable<Users[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<Users[]>('/api/v1/user/managers/', { headers })
      .pipe(catchError(this.errorHandler));
  }

  retrievePermissions(userId: any): Observable<UserPermissions[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<UserPermissions[]>('/api/v1/rule/user/' + userId, { headers })
      .pipe(catchError(this.errorHandler));
  }


  deletePermission(permissionId: any) {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.delete('/api/v1/rule/' + permissionId, { headers })
      .pipe(catchError(this.errorHandler));
  }


  createPermission(userPermission: UserPermissions): Observable<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.post<any>('/api/v1/rule/', userPermission, { headers })
      .pipe(catchError(this.errorHandler));
  }

  deleteUser(userId: any) {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.delete('/api/v1/user/' + userId, { headers })
      .pipe(catchError(this.errorHandler));
  }

  retrieveAllRoles(): Observable<UserRole[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<UserRole[]>('/api/v1/role/', { headers })
      .pipe(catchError(this.errorHandler));
  }


  public createRole(obj: any): Observable<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.post<any>('/api/v1/role/', obj, { headers }).pipe(catchError(this.errorHandler));
  }

  updateRole(bean: any): Observable<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.put<any>('/api/v1/role/', bean, { headers }).pipe(catchError(this.errorHandler));
  }

  public deleteRole(Id: number) {
    return this.httpClient.delete('api/v1/role/' + Id);
  }

  createUser(userDTO: Users): Observable<any> {

    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.post<any>('/api/v1/user/', userDTO, { headers })
      .pipe(catchError(this.errorHandler));

  }

  updateUser(userDTO: Users): Observable<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.put<any>('/api/v1/user/', userDTO, { headers }).pipe(catchError(this.errorHandler));
  }

  retrieveBrandLeadUsers(): Observable<BrandLeadUser[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<BrandLeadUser[]>('/api/v1/brandleaduser/', { headers })
      .pipe(catchError(this.errorHandler));
  }

  addBrandLeadUserItem(item: any): Observable<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.post<any>('/api/v1/brandleaduser/', item, { headers })
      .pipe(catchError(this.errorHandler));
  }

  deleteBrandLeadUserItem(itemId: any) {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.delete('/api/v1/brandleaduser/' + itemId, { headers })
      .pipe(catchError(this.errorHandler));
  }

  retrieveTechLeads(): Observable<Users[]> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    return this.httpClient.get<Users[]>('/api/v1/user/techLeads/', { headers })
      .pipe(catchError(this.errorHandler));
  }

  // appliance roles
  retriveApplianceRoles(): Observable<ApplianceRole[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<ApplianceRole[]>(this.AppliancePATH + '/roles' , {headers})
      .pipe(catchError(this.errorHandler));
  }

  deleteApplianceRole(itemId: number) {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.delete(this.AppliancePATH + 'deleteRole/' + itemId , {headers})
      .pipe(catchError(this.errorHandler));
  }

  createApplianceRole(role: ApplianceRole): Observable<any> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.post<any>(this.AppliancePATH + '/addRole', role , {headers})
      .pipe(catchError(this.errorHandler));

  }

  updateApplianceRole(role: ApplianceRole): Observable<any> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.put<any>(this.AppliancePATH + '/updateRole', role , {headers})
      .pipe(catchError(this.errorHandler));
  }

  getTagsByUserId(userId: number): Observable<any[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<any[]>(`/appliances/api/v2/user/get-tags/${userId}`, { headers })
      .pipe(catchError(this.errorHandler));
  }

  getAllTagTypes(): Observable<string[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<string[]>(`/appliances/api/v2/user/all-tag-types`, { headers })
      .pipe(catchError(this.errorHandler));
  }

  getTagsByType(tagType: string): Observable<any[]> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<any[]>(`/appliances/api/v2/user/tag-by-type/${tagType}`, { headers })
      .pipe(catchError(this.errorHandler));
  }

  addTagsToUser(userId: number, tagIds: number[]): Observable<any> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.post<any>(`/appliances/api/v2/user/add-tags/${userId}`, tagIds, { headers })
      .pipe(catchError(this.errorHandler));
  }

  deleteTagFromUser(userId: number, tagId: number): Observable<any> {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.delete<any>(`/appliances/api/v2/user/delete-tag/${userId}/${tagId}`, { headers })
      .pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    console.log(error.message);
    return throwError(error.message || 'Server Error');
  }


}
